import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DevicesAllComponent} from './components/devices-all/devices-all';

const routes: Routes = [
    {
        path: '',
        component: DevicesAllComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DevicesRoutingModule {
}
